import React, { useEffect, useRef } from 'react'
import { motion, useInView } from 'framer-motion'

//Multimedia
// import House from '../../Imgs/svg/House.svg'
import houseAlone from '../../Imgs/HowWork/house.svg'
import laptop from '../../Imgs/HowWork/laptop.svg'
import documentIcon from '../../Imgs/HowWork/document.svg'
import delivery from '../../Imgs/HowWork/delivery.svg'
import deliveryMan from '../../Imgs/HowWork/deliver.svg'

import checkIcon from '../../Imgs/Home/check.svg'

function HowWorks() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const headerRef = useRef(null)
  const step1Ref = useRef(null)
  const step2Ref = useRef(null)
  const step3Ref = useRef(null)
  const step4Ref = useRef(null)
  const step5Ref = useRef(null)

  const headerInView = useInView(headerRef, { once: true, amount: 0.3 })
  const step1InView = useInView(step1Ref, { once: true, amount: 0.3 })
  const step2InView = useInView(step2Ref, { once: true, amount: 0.3 })
  const step3InView = useInView(step3Ref, { once: true, amount: 0.3 })
  const step4InView = useInView(step4Ref, { once: true, amount: 0.3 })
  const step5InView = useInView(step5Ref, { once: true, amount: 0.3 })

  const classIcons = 'hidden md:block  h-[90px] w-[90px] mr-[25px] md:mr-0'

  const classIconsMobile = 'block md:hidden h-[70px] w-[70px] p-[8px]'

  return (
    <>
      <div className=" flex justify-center">
        <div className="container">
          <motion.div
            ref={headerRef}
            initial={{ opacity: 0, y: 30 }}
            animate={headerInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
            className="m-[40px] md:m-[80px] grid grid-cols-1 md:grid-cols-2  justify-center   items-center"
          >
            <div className="flex flex-col mb-[100px]">
              <h1 className=" tituloPrincipal text-center md:text-left mb-[30px] md:mb-[60px]">
                ¿Cómo funciona Pide y Pasa?
              </h1>
              <p className=" textoGeneral text-justify">
                Pide y Pasa opera como una plataforma tecnológica B2B (Business
                to Business), ofreciendo a los restaurantes:
              </p>
              <ul className="mt-5 space-y-3 mx-[10px] list-none pl-0 !flex-col !justify-start">
                <li className="flex items-start gap-3">
                  <img
                    src={checkIcon}
                    alt="check"
                    className="w-6 h-6 flex-shrink-0 mt-1"
                  />
                  <span className="text-sm md:text-xl">
                    Acceso a su sistema digital mediante un modelo de comisión
                    (según el acuerdo comercial definido).
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <img
                    src={checkIcon}
                    alt="check"
                    className="w-6 h-6 flex-shrink-0 mt-1"
                  />
                  <span className="text-sm md:text-xl">
                    Implementación y configuración de la plataforma para el
                    establecimiento.
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <img
                    src={checkIcon}
                    alt="check"
                    className="w-6 h-6 flex-shrink-0 mt-1"
                  />
                  <span className="text-sm md:text-xl">
                    Soporte y acompañamiento en la adopción de la herramienta.
                  </span>
                </li>
              </ul>
            </div>
          </motion.div>
          <motion.div
            ref={step1Ref}
            initial={{ opacity: 0, x: -50 }}
            animate={step1InView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6 }}
            className=" items-center justify-center md:justify-evenly flex"
          >
            <img src={houseAlone} alt="" srcSet="" className={classIcons} />
            <div className="items-start relative border-l-2 pl-[30px] flex gap-7 flex-col w-[75%] md:w-[40%] ">
              <figure>
                {' '}
                <img
                  src={houseAlone}
                  alt=""
                  srcSet=""
                  className="block md:hidden h-[80px] w-[80px] p-[8px]"
                />
              </figure>
              <p className=" text-base  text-center md:text-left text-[#979797]">
                Paso 1
              </p>
              <h1 className="tituloSecundario tituloSecundario text-left ">
                Registra tu restaurante
              </h1>
              <p className=" textoGeneral text-justify mb-[60px] md:mb-[100px]">
                Elige una categoría para tu restaurante y entrega fácil a tus
                clientes los productos el mismo día.
              </p>
              <div className="left-[-6px] top-0 absolute h-[10px] w-[10px] bg-slate-800"></div>
            </div>
          </motion.div>
          <motion.div
            ref={step2Ref}
            initial={{ opacity: 0, x: -50 }}
            animate={step2InView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6 }}
            className=" items-center justify-center md:justify-evenly flex"
          >
            <img src={laptop} alt="" srcSet="" className={classIcons} />
            <div className="items-start relative border-l-2 pl-[30px] flex gap-7 flex-col w-[75%] md:w-[40%] ">
              <figure>
                <img
                  src={laptop}
                  alt=""
                  srcSet=""
                  className="block md:hidden h-[80px] w-[80px] p-[8px]"
                />
              </figure>
              <p className="  text-base  text-center md:text-left text-[#979797]">
                Paso 2
              </p>
              <h1 className="tituloSecundario text-left ">
                Recibe el pedido del cliente
              </h1>
              <p className=" textoGeneral text-justify mb-[70px] md:mb-[100px]">
                Coloca "online" tu negocio para recibir los pedidos de los
                clientes en el control de pedidos y de esta manera organizar las
                órdenes.
              </p>
              <div className="left-[-6px] top-0 absolute h-[10px] w-[10px] bg-slate-800"></div>
            </div>
          </motion.div>
          <motion.div
            ref={step3Ref}
            initial={{ opacity: 0, x: -50 }}
            animate={step3InView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6 }}
            className=" items-center justify-center md:justify-evenly flex"
          >
            <img
              src={documentIcon}
              alt=""
              srcSet=""
              className="hidden md:block  h-[80px] w-[90px] mr-[25px] md:mr-0"
            />
            <div className="items-start relative border-l-2 pl-[30px] flex gap-7 flex-col w-[75%] md:w-[40%] ">
              <figure>
                <img
                  src={documentIcon}
                  alt=""
                  srcSet=""
                  className="block md:hidden h-[70px] w-[80px] p-[8px]"
                />
              </figure>
              <p className="  text-base  text-center md:text-left text-[#979797]">
                Paso 3
              </p>
              <h1 className="tituloSecundario text-left ">
                Espera la confirmación de recogida
              </h1>
              <p className=" textoGeneral text-justify mb-[70px] md:mb-[100px]">
                Espera la notificación del cliente "mandar a preparar" para que
                alistes todos los productos e ingredientes de su pedido.
              </p>
              <div className="left-[-6px] top-0 absolute h-[10px] w-[10px] bg-slate-800"></div>
            </div>
          </motion.div>
          <motion.div
            ref={step4Ref}
            initial={{ opacity: 0, x: -50 }}
            animate={step4InView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6 }}
            className=" items-center justify-center md:justify-evenly flex"
          >
            <img src={delivery} alt="" srcSet="" className={classIcons} />
            <div className="items-start relative border-l-2 pl-[30px] flex gap-7 flex-col w-[75%] md:w-[40%] ">
              <figure>
                <img
                  src={delivery}
                  alt=""
                  srcSet=""
                  className={classIconsMobile}
                />
              </figure>
              <p className="  text-base  text-center md:text-left text-[#979797]">
                Paso 4
              </p>
              <h1 className="tituloSecundario text-left ">
                En camino al restaurante
              </h1>
              <p className=" textoGeneral text-justify mb-[70px] md:mb-[100px]">
                Una vez el cliente notifica, el sistema indicará cuando va
                retirar, selecciona el tiempo estimado de preparación y entrega.
              </p>
              <div className="left-[-6px] top-0 absolute h-[10px] w-[10px] bg-slate-800"></div>
            </div>
          </motion.div>
          <motion.div
            ref={step5Ref}
            initial={{ opacity: 0, x: -50 }}
            animate={step5InView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6 }}
            className=" items-center justify-center md:justify-evenly flex"
          >
            <img src={deliveryMan} alt="" srcSet="" className={classIcons} />
            <div className="items-start relative  pl-[30px] flex gap-7 flex-col w-[75%] md:w-[40%] ">
              <figure>
                <img
                  src={deliveryMan}
                  alt=""
                  srcSet=""
                  className={classIconsMobile}
                />
              </figure>

              <p className="  text-base  text-center md:text-left text-[#979797]">
                Paso 5
              </p>
              <h1 className="tituloSecundario text-left ">Retiro del pedido</h1>
              <p className=" textoGeneral text-justify mb-[70px] md:mb-[100px]">
                Pídele al cliente el número PIN de entrega para que reciba su
                orden según el método de entrega seleccionado.
              </p>
              <div className="left-[-6px] top-0 absolute h-[10px] w-[10px] bg-slate-800"></div>
            </div>
          </motion.div>
          <div className="mx-auto w-[90%]">
            <p className="textoGeneral text-justify container">
              Los clientes finales realizan sus pedidos a través de la
              plataforma digital, seleccionan el horario de recogida y pasan por
              su pedido en el momento indicado, sin esperas innecesarias.
            </p>
            <p className="mt-4 textoGeneral text-justify container mb-10">
              De esta manera, Pide y Pasa no solo digitaliza el proceso de
              compra, sino que optimiza la operación del restaurante y eleva la
              experiencia del consumidor, alineándose con las nuevas tendencias
              del sector FoodTech y el consumo bajo demanda.
            </p>
          </div>
        </div>
      </div>
    </>
  )
}

export default HowWorks
